import React, { useContext } from 'react'
import ComingSoon from '../components/ComingSoon'
import NotAuthorised from '../components/NotAuthorised'
import SubscriptionGate from '../components/Subscriptions/SubscriptionGate'
import { UserContext } from '../App'
import PTSBookings from '../pages/patientTransport/Bookings/Bookings'
import PTSControllerOverview from '../pages/patientTransport/Control/PTSControl'
import PTSCrewView from '../pages/patientTransport/CrewView/CrewView'
import PTSDutiesPage from '../pages/patientTransport/Duties'
import NewPTSBooking from '../pages/patientTransport/NewBooking/NewBooking'
import Organisations from '../pages/patientTransport/Organisations/Organisations'
import HospitalBookingPortal from '../pages/patientTransport/HospitalPortal/HospitalBookingPortal'
import PTSPatient from '../pages/patientTransport/Patients/Patient'
import PTSPatientList from '../pages/patientTransport/Patients/PatientList'
import SingleBooking from '../pages/patientTransport/SingleBooking/SingleBooking'
import PTSReports from '../pages/patientTransport/Reports/PTSReports'
import PlanningTimeline from '../pages/patientTransport/Timeline/PlanningTimeline'
import PatientTimeline from '../pages/patientTransport/Timeline/PatientTimeline'
import PTSInvoices from '../pages/patientTransport/Invoices/PTSInvoices'
import JourneyTracking from '../pages/patientTransport/Tracking/JourneyTracking'

export const PTSUpgrade = ({ module, onGoBack }) => (
  <SubscriptionGate
    requiredTier={3}
    featureName="Patient Transport"
    benefits={[
      'Streamline patient transport bookings, allocation, and journey tracking from one connected platform',
      'Improve operational visibility with live status updates, dispatch oversight, and resource coordination',
      'Reduce administrative workload through digital bookings, automated workflows, and centralised records',
      'Support safer, more compliant transport operations with integrated governance, audit trails, and reporting',
    ]}
    onGoBack={onGoBack}
  >
    {module}
  </SubscriptionGate>
)

const PTSCoordinatorGate = ({ children }) => {
  const { user } = useContext(UserContext)
  const hasCoordinatorAccess =
    user?.employee?.ptsAccess?.includes('CoOrdinator') ||
    user?.security?.isSiteAdmin

  if (!hasCoordinatorAccess) {
    return (
      <NotAuthorised message="This area is for PTS Co-Ordinators. Your access covers the active PTS duty screen - please speak to your administrator if you need planner or control-room access." />
    )
  }

  return children
}

const PTSCoordinatorUpgrade = ({ module }) => (
  <PTSUpgrade module={<PTSCoordinatorGate>{module}</PTSCoordinatorGate>} />
)

export default [
  // Public tracking page — no coordinator gate. Registered here too (as
  // well as PublicRouter.js) so it still works when opened on a device that
  // already has a staff AmbuNet session (PublicRouter only renders when
  // logged out).
  { path: '/track/:token', element: <JourneyTracking /> },
  {
    path: '/pts/bookings',
    element: <PTSCoordinatorUpgrade module={<PTSBookings />} />,
    title: 'PTS Bookings',
  },
  {
    path: '/pts/bookings/new-booking',
    element: <PTSCoordinatorUpgrade module={<NewPTSBooking />} />,
    title: 'New PTS Booking',
  },
  {
    path: '/pts/bookings/:bookingID',
    element: <PTSCoordinatorUpgrade module={<SingleBooking />} />,
    title: 'PTS Booking',
  },
  {
    path: '/pts/planning',
    element: <PTSCoordinatorUpgrade module={<PTSDutiesPage />} />,
    title: 'Patient Transport',
  },
  {
    path: '/pts/planning/timeline',
    element: <PTSCoordinatorUpgrade module={<PlanningTimeline />} />,
    title: 'Patient Transport',
  },
  {
    path: '/pts/planning/patient-timeline',
    element: <PTSCoordinatorUpgrade module={<PatientTimeline />} />,
    title: 'Patient Transport',
  },
  {
    path: '/pts/patients',
    element: <PTSCoordinatorUpgrade module={<PTSPatientList />} />,
    title: 'Patient Transport',
  },
  {
    path: '/pts/patients/:patientID',
    element: <PTSCoordinatorUpgrade module={<PTSPatient />} />,
    title: 'Patient Transport',
  },
  // { path: '/pts/control', element: <ComingSoon /> },
  {
    path: '/pts/control',
    element: <PTSCoordinatorUpgrade module={<PTSControllerOverview />} />,
    title: 'Patient Transport',
  },
  {
    path: '/pts/audits',
    element: <PTSCoordinatorUpgrade module={<ComingSoon />} />,
    title: 'PTS Audits'
  },
  {
    path: '/pts/organisations',
    element: <PTSCoordinatorUpgrade module={<Organisations />} />,
    title: 'Hospitals'
  },
  {
    path: '/pts/reports',
    element: <PTSCoordinatorUpgrade module={<PTSReports />} />,
    title: 'PTS Reports'
  },
  {
    path: '/pts/invoices',
    element: <PTSCoordinatorUpgrade module={<PTSInvoices />} />,
    title: 'PTS Invoices'
  },
  {
    path: '/pts/hospital-portal-preview/:organisationID',
    element: (
      <PTSCoordinatorUpgrade module={<HospitalBookingPortal previewMode />} />
    ),
  },
  {
    path: '/pts',
    element: (
      <SubscriptionGate requiredTier={3}>
        <PTSCrewView />
      </SubscriptionGate>
    ),
    title: 'Patient Transport'
  },
]
